// extracted by mini-css-extract-plugin
export default {"formContainer":"Register_formContainer__jB3TW","inputField":"Register_inputField__0n3ox","submitButton":"Register_submitButton__-kZfz"};